<template>
  <div>
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          {{ $page.props.classroom && $page.props.classroom.data.name }}
        </h2>
      </div>
      <div class="col-2">
        <inertia-link :href="route('classrooms.assigned')" class="float-right">
          Back to classrooms
        </inertia-link>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-2 p-3">
        <nav class="classroom-sidebar nav flex-column nav-pills">
          <inertia-link
            class="nav-link"
            :class="{ 'active' : route().current('*overview*')}"
            :href="
              route(
                'classrooms.assigned.view.overview',
                $page.props.classroom.data.id
              )
            "
          >
            Overview
          </inertia-link>
          <inertia-link
            class="nav-link"
            :class="{ 'active' : route().current('*sessions*') || route().current('*content*')}"
            :href="
              route(
                'classrooms.assigned.view.sessions',
                $page.props.classroom.data.id
              )
            "
          >
            Sessions
          </inertia-link>
          <!-- <a class="nav-link" href="#">Assignments</a>
          <a class="nav-link disabled" href="#">Resources</a> -->
        </nav>
      </div>

      <div class="col-md-10 p-3 card shadow-sm bg-white rounded">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
};
</script>